/* eslint-disable no-new */
import CollectionFacets from '../components/svelte/CollectionFacets.svelte';
import CollectionGrid from '../components/svelte/CollectionGrid.svelte';
import positionFacetsBarOnScroll from './searchanise-facet-bar-positioner.js';

function setFilterMenuHeight() {
  const filtersMenu = document.querySelector('[data-filters-menu]');
  filtersMenu.style.setProperty('--height', `${window.innerHeight}px`);
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = {
    facets: document.querySelector('[data-searchanise-collection-facets]'),
    facetsPositionMarker: document.querySelector(
      '[data-collection-facets-position-marker]'
    ),
    grid: document.querySelector('[data-searchanise-collection-grid]'),
  };

  if (containers.grid) {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q') || '';
    const collection = JSON.parse(
      containers.grid.dataset.searchaniseCollectionGrid || null
    );

    const featuredProduct = JSON.parse(
      containers.grid.dataset.featuredProduct || null
    );

    const {
      featuredProductImage,
      featuredProductVideo,
      featuredProductShopifyVideo,
    } = containers.grid.dataset;

    if (query && !collection) {
      document.title = `Search for "${query}"`;
    }

    new CollectionFacets({
      target: containers.facets,
      props: {
        collection,
        query,
      },
    });

    new CollectionGrid({
      target: containers.grid,
      props: {
        collection,
        featuredProduct: featuredProduct || null,
        featuredProductImage,
        featuredProductVideo,
        featuredProductShopifyVideo,
        query,
      },
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
      document.addEventListener('scroll', positionFacetsBarOnScroll);
    }

    setTimeout(() => {
      setFilterMenuHeight();
    }, 500);
  }
});

window.addEventListener('resize', () => {
  setFilterMenuHeight();
});
